module.exports = __webpack_public_path__ + "img/gift.8d030aeb.svg";